import React from "react";
import './Events.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export default function Event() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: "true",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="event">
      <div className="container-fluid">
        <div className="content">
          <h2>Upcoming <span>events</span></h2>
          <div className="row">
            <div className="col-md-5">
              <img className="img-fluid graduate-img" src={require('../../Images/scholar.png')} alt="graduate-img"/>
            </div>
            <div className="col-md-7">
              <Slider {...settings}>
                <div className="card mb-3 ">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="card-icon">
                        <i className="bi bi-highlighter"></i>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">The Kindred Networking</h5>
                        <p className="card-text">Wear retro colors and join us for this inspiring and educational networking event!</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-3">
                  <div className="row g-5">
                    <div className="col-md-4">
                      <div className="card-icon">
                        <i className="bi bi-book"></i>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">Lorem ipsum</h5>
                        <p className="card-text">Wear retro colors and join us for this inspiring and educational networking event!</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-3">
                  <div className="row g-5">
                    <div className="col-md-4">
                      <div className="card-icon">
                        <i className="bi bi-hand-thumbs-up"></i>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">The Kindred Networking</h5>
                        <p className="card-text">Wear retro colors and join us for this inspiring and educational networking event!</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-3">
                  <div className="row g-5">
                    <div className="col-md-4">
                      <div className="card-icon">
                        <i className="bi bi-asterisk"></i>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">The Kindred Networking</h5>
                        <p className="card-text">Wear retro colors and join us for this inspiring and educational networking event!</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-3">
                  <div className="row g-5">
                    <div className="col-md-4">
                      <div className="card-icon">
                        <i className="bi bi-award"></i>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">The Kindred Networking</h5>
                        <p className="card-text">Wear retro colors and join us for this inspiring and educational networking event!</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-3">
                  <div className="row g-5">
                    <div className="col-md-4">
                      <div className="card-icon">
                        <i className="bi bi-bounding-box"></i>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">The Kindred Networking</h5>
                        <p className="card-text">Wear retro colors and join us for this inspiring and educational networking event!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
